<h3 class="header">Edita la inversión</h3>

<!-- User Available Balance -->
<div class="balance-section">
  <p class="section-title">Saldo disponible del usuario:</p>
  <div class="balance-row">
    <div class="balance-item">
      <app-amount *ngIf="penBalance" mode="balance" [amount]="penBalance" currency="pen"></app-amount>
    </div>
    <div class="balance-item">
      <app-amount *ngIf="usdBalance" mode="balance" [amount]="usdBalance" currency="usd"></app-amount>
    </div>
  </div>
</div>

<!-- Invoice Available Amount -->
<div class="invoice-amount-section">
  <p class="section-title">Monto disponible de la factura</p>
  <lib-money [amount]="projectedAvailableAmount || '0.00'" [currency]="currency || 'pen'"></lib-money>
</div>

<!-- Edit Form -->
<div class="form" [formGroup]="form" (ngSubmit)="submit()">
  <!-- Amount Input -->
  <div class="form-field">
    <app-input formControlName="amount" autocomplete="off" type="number" label="Monto"> </app-input>
  </div>

  <!-- Investment Date -->
  <div class="form-field">
    <app-date-picker formControlName="investmentDate" label="Fecha de inversión"> </app-date-picker>
  </div>

  <!-- Action Buttons -->
  <div class="button-container button-direction-column">
    <fs-ui-button [action]="'submit'" (click)="submit()" [label]="'Guardar'" [isDisabled]="!form.valid"> </fs-ui-button>
    <fs-ui-button (click)="cancel()" [label]="'Cancelar'" [type]="'tertiary'"> </fs-ui-button>
  </div>
</div>
